import React, { useEffect, useState } from "react";
import { Lab, LowQuantityAlert } from "../../../../backend/src/types";
import {
  getAlertsCount,
  getAlertsList,
  handleHiddenAlert,
} from "../../fetch/AlertRequest";
import styles from "../../styles/modules/MainPage.module.css";
import "../../styles/sanitize.css";
import { useUser } from "../../contexts/UserContext";

interface LowQuantityListProps {
  onFinish: () => void;
  isLabAdmin: boolean;
  selectedLab: Lab;
}

const LowQuantityList: React.FC<LowQuantityListProps> = ({
  onFinish,
  isLabAdmin,
  selectedLab,
}) => {
  const [lowQuantityList, setLowQuantityList] = useState<LowQuantityAlert[]>([]);
  const { user, userLabs, setAlertCount } = useUser();

  useEffect(() => {
    loadLowQuantityAlertList();
  }, [selectedLab]);

  async function loadLowQuantityAlertList() {
    const result = await getAlertsList<LowQuantityAlert>({
      tenant_id: selectedLab.tenant_id,
      lab_id: selectedLab.id,
      category: "low_quantity",
    });

    setLowQuantityList(result);
    onFinish();
  }

  const handleHide = async (id: number) => {
    await handleHiddenAlert({ alertId: id });

    setLowQuantityList((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, is_resolved: true } : item,
      ),
    );

    if (user?.tenant_id) {
      const tenant_id = user.tenant_id;
      const lab_ids = userLabs.map((lab) => lab.id);
      const alertCount = await getAlertsCount({ tenant_id, lab_ids });
      setAlertCount(alertCount);
    }
  };

  return (
    <div className={styles["alert-section"]}>
      <h3>最低残量不足一覧</h3>

      <table>
        <thead>
          <tr>
            <th>試薬名</th>
            <th>試薬ID</th>
            <th>現在残量</th>
            <th>最低残量</th>
            {isLabAdmin && <th>非表示</th>}
          </tr>
        </thead>
        <tbody>
          {lowQuantityList.filter((alert) => !alert.is_resolved).length > 0 ? (
            lowQuantityList
              .filter((alert) => !alert.is_resolved)
              .map((alert) => (
                <tr key={alert.id}>
                  <td>{alert.name}</td>
                  <td>{alert.reagent_id}</td>
                  <td>
                    {alert.quantity_base}
                    {alert.display_unit}
                  </td>
                  <td>
                    {alert.min_quantity_base}
                    {alert.display_unit}
                  </td>
                  {isLabAdmin && (
                    <td>
                      <button onClick={() => handleHide(alert.id)}>
                        非表示
                      </button>
                    </td>
                  )}
                </tr>
              ))
          ) : (
            <tr>
              <td colSpan={isLabAdmin ? 5 : 4}>
                <p className="list-none">アラートなし</p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LowQuantityList;